import { getChannel } from "@website/utils/channel/get-channel";
import { logoSchema } from "@website/widget/header/logo/schema";

export function Logo({ minimalLogo }: { minimalLogo?: boolean }) {
  const { label, image, title } = minimalLogo
    ? logoSchema.minimal
    : logoSchema[getChannel() as keyof typeof logoSchema] || logoSchema.default;
  return (
    <a aria-label={label} href="/">
      <img
        alt={`${label} logo`}
        className="h-8 w-auto lg:h-10"
        height={78}
        loading="lazy"
        fetchPriority="high"
        src={(image as unknown as { src: string }).src as string}
        title={title}
        width={137}
      />
    </a>
  );
}
